export default __webpack_public_path__ + "static/media/pensionsdagen2024.ac154974.jpg";